module.exports = __webpack_public_path__ + "static/media/econimg.cd07e703.JPG";